import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/code/build/apps/web/src/app/[locale]/(admin)/dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer","PageHeader","PageIcon","PageTitle","PageContent"] */ "/app/code/build/apps/web/src/app/components/page-layout.tsx");
